import i18n from '@/plugins/vue-i18n'

export const EVALUATIONS_OPTIONS = new Map([
  [1, i18n.tc('evaluationOptions.yes')],
  [0, i18n.tc('evaluationOptions.no')],
  [0.5, i18n.tc('evaluationOptions.partial')],
  [null, i18n.tc('evaluationOptions.dont_consider')],
])
